// tslint:disable
/**
 * Robotic Platform Pattern Generation API
 * WebSocket API contract for generating palletization strategy templates and layer layouts.  This module is exposed through the Robotic Platform WebSocket dispatcher (not a standalone REST API). The OpenAPI path below documents the JSON request/response message payload for the `generatePatternPlan` handler.  Transport notes: - Connect to the WebSocket server and send a JSON object with top-level `type: generatePatternPlan` - Receive one JSON response frame for the request (success or handler-level error) - Validation and internal handler errors are encoded in the JSON response body with `status: error` - No module-level authentication or rate limiting is implemented in this repository 
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Box } from './box';
import { BoxLeadingMode } from './box-leading-mode';
import { GenerationOptions } from './generation-options';
import { Pallet } from './pallet';

/**
 * WebSocket request payload for the `generatePatternPlan` handler. Unknown top-level fields are currently ignored by backend validation/parsing. 
 * @export
 * @interface GeneratePatternPlanMessage
 */
export interface GeneratePatternPlanMessage {
    [key: string]: object | any;

    /**
     * WebSocket message type used by the core dispatcher/router.
     * @type {string}
     * @memberof GeneratePatternPlanMessage
     */
    type: GeneratePatternPlanMessageTypeEnum;
    /**
     * 
     * @type {BoxLeadingMode}
     * @memberof GeneratePatternPlanMessage
     */
    boxLeading?: BoxLeadingMode;
    /**
     * 
     * @type {Box}
     * @memberof GeneratePatternPlanMessage
     */
    box: Box;
    /**
     * 
     * @type {Pallet}
     * @memberof GeneratePatternPlanMessage
     */
    pallet: Pallet;
    /**
     * 
     * @type {GenerationOptions}
     * @memberof GeneratePatternPlanMessage
     */
    options?: GenerationOptions;
}

/**
    * @export
    * @enum {string}
    */
export enum GeneratePatternPlanMessageTypeEnum {
    GENERATEPATTERNPLAN = 'generatePatternPlan'
}



